import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from 'components/theme/Button'
import { toggleModal } from 'actions/phone'
import { withStyles } from '@material-ui/core'
import { Phone } from '@material-ui/icons'
import secondsToDhms from 'utils/secondsToDhms'

const styles = (theme) => ({
  container: {
    height: 64,
    position: 'fixed',
    top: 0,
    right: 0,
    backgroundColor: '#eee',
    zIndex: 1202,
    [theme.breakpoints.down('sm')]: {
      height: 56,
    },
  },
})

class PhoneTime extends Component {
  state = { time: 0 }

  componentDidUpdate(prevProps) {
    if (this.props.startTime !== prevProps.startTime && this.props.startTime) {
      console.log(
        'this.props.startTime !== prevProps.startTime && this.props.startTime',
      )
      this.timerID = setInterval(() => this.tick(), 1000)
    }

    if (this.props.startTime !== prevProps.startTime && !this.props.startTime) {
      console.log(
        'this.props.startTime !== prevProps.startTime && !this.props.startTime',
      )
      clearInterval(this.timerID)
      this.setState({ time: 0 })
    }
  }

  componentWillUnmount() {
    this.setState({ time: 0 })
    clearInterval(this.timerID)
  }

  tick() {
    if (this.props.startTime) {
      this.setState({
        time: Math.floor((Date.now() - this.props.startTime) / 1000),
      })
    }
  }

  render() {
    const { startTime, classes, toggleModal } = this.props

    return (
      <div
        style={startTime ? null : { display: 'none' }}
        className={classes.container}
      >
        <div style={{ position: 'relative', height: '100%' }}>
          <Button
            style={{
              position: 'absolute',
              top: '50%',
              right: 5,
              transform: 'translate(0, -50%)',
            }}
            variant="contained"
            onClick={() => toggleModal(true)}
          >
            <Phone style={{ marginRight: 5 }} />
            {secondsToDhms(this.state.time)}
          </Button>
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({ startTime: state.phone.startTime }),
  (dispatch) => bindActionCreators({ toggleModal }, dispatch),
)(withStyles(styles)(PhoneTime))
